import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  checklistTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import {
  ITemplateEditorChecklistTemplateVersion,
  TemplateEditorChecklistTemplateVersion,
} from '@core/entities/checklist/TemplateEditorChecklistTemplateVersion'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const projectChecklistTransform = (
  data: ITemplateEditorChecklistTemplateVersion,
) => TemplateEditorChecklistTemplateVersion.new(data)

export const useGetProjectChecklistTemplateVersion = (
  payload: RequestTypes['getProjectChecklistTemplateVersion'],
  options?: UseQueryOptions<
    ITemplateEditorChecklistTemplateVersion,
    RequestErrorType,
    TemplateEditorChecklistTemplateVersion
  >,
) => {
  return useQuery<
    ITemplateEditorChecklistTemplateVersion,
    RequestErrorType,
    TemplateEditorChecklistTemplateVersion
  >({
    select: projectChecklistTransform,
    ...checklistTemplateKeys.getProjectVersion(payload),
    ...options,
  })
}
